export const REQUESTS_RECEIPTS_SLICE_NAME = "requestsReceipts"
